export default __webpack_public_path__ + "static/media/gray-img.bb8a1f08.svg";